export enum ImageSuffixEnum {
  jpeg = "jpeg",
  png = "png",
  svg = "svg",
}
